import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { FilterCompaniaModel } from 'src/app/models/compania/FilterCompaniaModel';
import { IFilterCompaniaModel } from 'src/app/models/interfaces/compania/IFilterCompaniaModel';
import { IFilterSedeModel } from 'src/app/models/interfaces/sedes/IFilterSedeModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { FilterSedeModel } from 'src/app/models/sede/FilterSedeModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { CompaniaService } from 'src/app/services/compania/compania.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';

@Component({
  selector: 'app-configuracion-sede-listar',
  templateUrl: './configuracion-sede-listar.component.html',
  styleUrls: ['./configuracion-sede-listar.component.css']
})
export class ConfiguracionSedeListarComponent implements OnInit {
  model!: SearchResultModel<ISedeModel[]>;
  filter: IFilterSedeModel = new FilterSedeModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();
  resultsLength = 0;
  currentPage = 0;

  displayedColumns: string[] = [
    //'id',
    'nombre',
    'companias',
    'nombrelenel',
    'zonaacceso',
    'estado',
    'acciones'
  ];
  
  @ViewChild('paginator') paginator!: MatPaginator;
  
  constructor(
    private serviceSede: SedeService,
    private serviceParametros: ParametroService,
    private companiaService: CompaniaService,
  ) { 
    this.model = new SearchResultModel<ISedeModel[]>(false, new Array<SedeModel>(), 0, 1, 0);
  }

  ngOnInit(): void {
    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_SEDE).subscribe((data) => {
      this.listaEstados = data.items;
    });
    
    this.serviceSede.getListFiltered(this.filter).subscribe((data) => {
      this.model = data;
      this.resultsLength = data.total;
    });
    
    let filterCompania: IFilterCompaniaModel = new FilterCompaniaModel();
    this.companiaService
      .getAllList(filterCompania)
      .subscribe((data: CompaniaModel[]) => {
        this.listaCompanias = data;
      });
  }

  search(): void{
    this.filter.page = 1;
    this.filter.pageSize = 30;
    this.serviceSede
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
        this.currentPage = 0;
        this.paginator.firstPage();
      });
  }

  getPaginatorData(event: any) {
    this.filter.page = event.pageIndex + 1;
    this.filter.pageSize = event.pageSize;
    this.serviceSede
      .getListFiltered(this.filter)
      .subscribe((data) => {
        this.model = data;
        this.resultsLength = data.total;
      });
  }
}
